import React from 'react';

const FilterBar = () => {
  return (
    <div className="mb-4">
      <button className="px-5 py-2 bg-blue-500 text-white rounded hover:bg-blue-600">
        Filters
      </button>
      
      <div className="mt-3 hidden">
        <div className="bg-white p-4 rounded shadow">
          <h3 className="font-medium mb-2">Filter Options</h3>
          
          <div className="mb-3">
            <h4 className="text-sm font-medium mb-1">Publication Date</h4>
            <div className="flex gap-2">
              <button className="px-3 py-1 bg-blue-100 text-blue-800 rounded text-sm">Last week</button>
              <button className="px-3 py-1 bg-gray-100 text-gray-800 rounded text-sm">Last month</button>
              <button className="px-3 py-1 bg-gray-100 text-gray-800 rounded text-sm">Last year</button>
            </div>
          </div>
          
          <div className="mb-3">
            <h4 className="text-sm font-medium mb-1">Cancer Types</h4>
            <div className="flex flex-wrap gap-2">
              <button className="px-3 py-1 bg-blue-100 text-blue-800 rounded text-sm">Melanoma</button>
              <button className="px-3 py-1 bg-blue-100 text-blue-800 rounded text-sm">Breast</button>
              <button className="px-3 py-1 bg-gray-100 text-gray-800 rounded text-sm">Colorectal</button>
              <button className="px-3 py-1 bg-gray-100 text-gray-800 rounded text-sm">Lung</button>
              <button className="px-3 py-1 bg-gray-100 text-gray-800 rounded text-sm">Hematologic</button>
            </div>
          </div>
          
          <div className="mb-3">
            <h4 className="text-sm font-medium mb-1">Article Type</h4>
            <div className="flex flex-wrap gap-2">
              <button className="px-3 py-1 bg-blue-100 text-blue-800 rounded text-sm">Clinical Trial</button>
              <button className="px-3 py-1 bg-gray-100 text-gray-800 rounded text-sm">Review</button>
              <button className="px-3 py-1 bg-gray-100 text-gray-800 rounded text-sm">Guidelines</button>
              <button className="px-3 py-1 bg-gray-100 text-gray-800 rounded text-sm">Meta-analysis</button>
            </div>
          </div>
          
          <div className="flex justify-end gap-2 mt-4">
            <button className="px-3 py-1 border border-gray-300 rounded">Reset</button>
            <button className="px-3 py-1 bg-blue-500 text-white rounded">Apply Filters</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;